module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/slider.760baae5.png";